import { clsx } from "clsx";
import { Text } from "../typography";

export type OrderStatus =
  | "delivered"
  | "inTransit"
  | "processing"
  | "cancelled"
  | "rejected"
  | "validated";

export interface StatusChipProps {
  status: OrderStatus;
  className?: string;
  label?: string;
}

const STATUS: Record<
  OrderStatus,
  { bg: string; text: string; label: string; border?: string }
> = {
  delivered: { bg: "bg-accentGreenTint", text: "text-accentGreenDark", label: "Delivered" },
  inTransit: { bg: "bg-accentBlueTint", text: "text-accentBlue", label: "In Transit" },
  processing: { bg: "bg-accentYellowTint", text: "text-accentError", label: "Processing" },
  cancelled:  { bg: "bg-borderDefault",    text: "text-textMuted",     label: "Cancelled"  },
  validated:  { bg: "bg-accentGreenTint",  text: "text-accentGreenDark", label: "Validated" },
  rejected: { bg: "bg-accentErrorTint", text: "text-accentError", label: "Rejected" },
};

export function StatusChip({ status, className, label }: StatusChipProps) {
  const style = STATUS[status];
  return (
    <span
      className={clsx(
        "inline-flex items-center justify-center rounded-[20px] px-3",
        style.bg,
        style.text,
        style.border,
        className,
      )}
    >
      <Text variant="bodyXs" tone="inherit" inline>
        {label ?? style.label}
      </Text>
    </span>
  );
}
